/**
 * 백테스팅 거래 내역 테이블 컴포넌트
 */
import { TradeLogEntry } from '../../types/performance';
import './TradesTable.css';

interface TradesTableProps {
  trades: TradeLogEntry[];
}

export default function TradesTable({ trades }: TradesTableProps) {
  return (
    <div className="trades-table-container">
      <div className="trades-table-header">
        <h3>거래 내역</h3>
        <span className="trades-count">{trades.length}건</span>
      </div>

      {trades.length === 0 ? (
        <div className="trades-empty">
          <div className="trades-empty-icon">
            <svg
              className="trades-empty-svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
          <p className="trades-empty-text">거래 기록이 없습니다</p>
          <p className="trades-empty-hint">
            거래가 발생하면 이곳에 내역이 표시됩니다
          </p>
        </div>
      ) : (
        <div className="trades-table-wrapper">
          <table className="trades-table">
            <thead>
              <tr>
                <th className="align-left">날짜</th>
                <th className="align-left">종목</th>
                <th className="align-left">유형</th>
                <th className="align-right">가격</th>
                <th className="align-right">수량</th>
                <th className="align-right">거래 금액</th>
                <th className="align-right">실현 손익</th>
                <th className="align-right">수익률</th>
              </tr>
            </thead>
            <tbody>
              {trades.map((trade, i) => (
                <tr key={i}>
                  <td className="date-cell">
                    {new Date(trade.date).toLocaleDateString()}
                  </td>
                  <td className="symbol-cell">
                    {trade.symbol || '-'}
                  </td>
                  <td>
                    <span
                      className={`trade-badge ${
                        trade.type?.toUpperCase() === 'BUY'
                          ? 'trade-badge-buy'
                          : 'trade-badge-sell'
                      }`}
                    >
                      {trade.type}
                    </span>
                  </td>
                  <td className="align-right price-cell">
                    {typeof trade.price === 'number'
                      ? `$${trade.price.toFixed(2)}`
                      : '-'}
                  </td>
                  <td className="align-right">
                    {typeof trade.qty === 'number' ? trade.qty.toFixed(2) : '-'}
                  </td>
                  <td className="align-right price-cell">
                    {typeof trade.value === 'number'
                      ? `$${trade.value.toFixed(2)}`
                      : '-'}
                  </td>
                  <td className="align-right">
                    <ProfitValue value={trade.profit} prefix="$" />
                  </td>
                  <td className="align-right">
                    <ProfitValue value={trade.profit_pct} suffix="%" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function ProfitValue({
  value,
  prefix = '',
  suffix = '',
}: {
  value?: number | null;
  prefix?: string;
  suffix?: string;
}) {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return <span className="profit-muted">-</span>;
  }

  const className = value >= 0 ? 'profit-positive' : 'profit-negative';
  const absValue = Math.abs(value).toFixed(2);
  const sign = value >= 0 ? '+' : '-';

  return (
    <span className={`profit-cell ${className}`}>
      {sign}
      {prefix}
      {absValue}
      {suffix}
    </span>
  );
}
